
import { connect } from "react-redux";
import { Table, Button } from "antd";
import store, { ReducerKeys } from "../reducers/";
import { Row, Col } from "antd";
import React, { Component } from "react";
import { path, pathOr } from "ramda";
import ModalUtil from "../util/modal";
import create from "../services/ApiSauce";
import * as OrgAction from "../actions/OrganizationAction";
import OrganizationActions from "../reducers/OrganizationReducer";
import ROUTE from "../constants/route";
import { history } from "../reducers/configureStore";

import { clearStore } from "../actions/StoreAction";
import { Layout, Menu, Divider, Avatar, Popover } from "antd";

const { Header, Content, Sider } = Layout;

const checkClick = (value) => {
	switch (value.key) {
	case "1":
		clearStore();
		break;
	default:
		return "no key detect";
	}
};


class CorporateList extends Component {
	state = {
		login: true,
		loading: false,
		data: null
	}
	async	componentDidMount() {
		try {
			OrgAction.getOrgByAdmin().then(data => {
				this.setState({ data });
			});
		} catch (error) {
			ModalUtil.showError(error);
		}
	}
	async	onOrganizationChoose(corp){
		const { token } = store.getState().authen;
		const { setOrganization, setOrganizationId } = this.props;
		try {
			setOrganizationId(corp.id);
			const response =	await create.create().getOrganization({ headers: { token: token, organization: corp.id } });
			const data = path(["data", "data"], response);
			if (response.ok && data) {
				setOrganization(data);
				history.push(`/${ROUTE.HOME}`);
			}
		} catch (error) {
			ModalUtil.showDefaultError();
			OrganizationActions.getOrganizationFailure();
		}
	}
	render() {
		const { data } = this.state;
		return (
			<Layout style={{ minHeight: "100vh", background: "#fff" }} >
				<Header style={{ background: "#fff", padding: "0 16px 0 16px" }}>
					<Popover placement="bottom" content={
						<Menu
							mode="horizontal"
							onClick={value => checkClick(value)}
						>
							<Menu.Item key="1" >
								<span>Log Out</span>
							</Menu.Item>
						</Menu>
					} trigger="click">
						<div style={{ float: "right", cursor: "pointer" }}>
							<Avatar size="large" icon="user"
								style={{ margin: "0 10px 0 10px", verticalAlign: "middle" }} />
							{store.getState()[ReducerKeys.USER].user.email}
						</div>
					</Popover>
					<Divider style={{ margin: 0, top: "64px" }} type="horizontal" />

				</Header>
				<Content style={{ padding: "0 16px", height: "calc(100vh - 64px)", overflowY: "scroll", overflowX: "hidden" }}>
					<Row align="middle" justify="center" type="flex" style={{ height: "100vh" }}>
						<Col span={10}>
							<h1 className="">Choose Corporate Which you want to see ?</h1>
							<Table
								rowKey="id"
								dataSource={data} columns={[
									{
										title: "Name",
										dataIndex: "name",
									},
									{
										title: "Action",
										render: (corp) => {
											return <Button onClick={() => {
												this.onOrganizationChoose(corp);
											}} type="primary">
												See
      						</Button>;
										}
									}
								]} />
						</Col>
					</Row>;
				</Content>
			</Layout>
		);

	}
}

// console.log(OrganizationActions.setOrganizationId(1));

const mapStateToDispatch = dispatch => ({
	setOrganizationId: (id) => dispatch(OrganizationActions.setOrganizationId(id)),
	setOrganization: (data) => dispatch(OrganizationActions.getOrganizationSuccess(data))


});

export default connect(null, mapStateToDispatch)(CorporateList);



// WEBPACK FOOTER //
// ./src/containers/CorporateList.js